var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSocialBee(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1009_11497)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.99951 13.9975C7.91565 14.036 8.8299 13.8835 9.68736 13.5492C10.5448 13.2149 11.3278 12.7057 11.9892 12.0522C12.6507 11.3986 13.177 10.6142 13.5365 9.74599C13.896 8.87782 14.0813 7.94381 14.0813 7.00007C14.0813 6.05633 13.896 5.12232 13.5365 4.25415C13.177 3.38597 12.6507 2.60155 11.9892 1.94798C11.3278 1.29441 10.5448 0.785192 9.68736 0.450901C8.8299 0.116609 7.91565 -0.0358577 6.99951 0.00266244C6.08337 -0.0358577 5.16912 0.116609 4.31167 0.450901C3.45421 0.785192 2.67125 1.29441 2.0098 1.94798C1.34835 2.60155 0.822069 3.38597 0.462557 4.25415C0.103046 5.12232 -0.0822754 6.05633 -0.0822754 7.00007C-0.0822754 7.94381 0.103046 8.87782 0.462557 9.74599C0.822069 10.6142 1.34835 11.3986 2.0098 12.0522C2.67125 12.7057 3.45421 13.2149 4.31167 13.5492C5.16912 13.8835 6.08337 14.036 6.99951 13.9975Z",
    fill: "url(#paint0_radial_1009_11497)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.012 12.2153C7.63562 13.5861 5.0589 13.8313 3.41332 13.0103C4.48908 13.6499 5.70786 13.9907 6.95014 13.9993C8.19243 14.0079 9.41557 13.6841 10.4996 13.0596C11.5696 12.454 12.4601 11.5613 13.0764 10.4763C13.6928 9.39138 14.0119 8.15479 13.9999 6.89805C13.8903 8.73316 12.3859 10.8393 10.012 12.2153ZM10.8638 1.41607C10.7221 1.17451 10.5264 0.971303 10.293 0.823383C11.1617 1.28173 11.9254 1.92547 12.5333 2.71166C12.6391 2.84568 12.7387 2.98444 12.8319 3.12797C13.0819 3.57 13.201 4.07754 13.1746 4.58827C13.1142 6.45192 11.461 8.71111 8.85657 10.2142C6.25213 11.7173 3.47128 12.0208 1.8257 11.1402C1.37268 10.9075 0.992706 10.5478 0.729493 10.1027L0.719413 10.0858C0.650112 9.94705 0.593411 9.80958 0.531671 9.66822C0.146901 8.74722 -0.0330458 7.74937 0.00498529 6.74761C0.0182398 7.03035 0.0973212 7.30568 0.235568 7.55039C1.07726 9.0068 4.14161 8.81616 7.07114 7.12241C10.0007 5.42866 11.7055 2.87248 10.8638 1.41607ZM7.88888 0.514721C7.86337 0.475979 7.83471 0.439536 7.8032 0.405782C7.60609 0.241805 7.37715 0.123166 7.13178 0.0578466C6.8864 -0.00747319 6.63029 -0.0179619 6.38065 0.0270865C6.28489 0.0348679 6.18157 0.0452456 6.07825 0.0621052C5.17148 0.180598 4.2956 0.478755 3.499 0.940103C2.70866 1.39099 2.0128 1.99836 1.45148 2.72723C1.38974 2.80763 1.33178 2.88934 1.27256 2.97104C1.10837 3.16364 0.988998 3.39221 0.923499 3.63941C0.858 3.8866 0.848101 4.14591 0.894554 4.39763C0.907498 4.44234 0.924367 4.48575 0.944955 4.52732C1.42628 5.36252 3.37426 5.14335 5.29074 4.0332C7.20722 2.92306 8.37021 1.34992 7.88888 0.514721Z",
    fill: "url(#paint1_radial_1009_11497)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_1009_11497",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(7.00077 6.92439) scale(6.99937 6.98813)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC614"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFDA5A"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_1009_11497",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(7.00058 6.91125) scale(6.99937 6.98813)"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#474A4B"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1009_11497"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSocialBee);
export default __webpack_public_path__ + "static/media/social_bee.37e0d855ef7c0c2b74797bfc48b671d4.svg";
export { ForwardRef as ReactComponent };